import request from '@/utils/request'

let CodeTemplateApi = {
  /*列表*/
   templateList(data) {
    return request._post('/shop/plus.codetemplate.codeTemplate/index', data);
  },
  /*添加*/
  addTemplate(data) {
    return request._post('/shop/plus.codetemplate.codeTemplate/add', data);
  },
  /*获取数据*/
  getTemplate(data) {
    return request._get('/shop/plus.codetemplate.codeTemplate/edit', data);
  },

  /*保存*/
  saveTemplate(data) {
    console.log(data)
    return request._post('/shop/plus.codetemplate.codeTemplate/edit', data);
  },
  /*删除*/
  delTemplate(data) {
    return request._post('/shop/plus.codetemplate.codeTemplate/delete', data);
  },

}
export default CodeTemplateApi;



// WEBPACK FOOTER //
// ./src/api/CodeTemplate.js